function sendFormData(e = null, _this = null) {
    if(e){
        e.preventDefault();
    }
    if(_this == null){
        _this = $(this);
    }

    let form_data = _this.closest("form").serializeArray();
    let data = [];
    form_data.forEach(function (v) {
        if (v.name !== '_do') {
            data.push(v);
        }
    });
    let href = _this.data("href");
    $.nette.ajax({
        url: href,
        data: data,
        type: 'POST',
        off: {
            snippets: false
        }
    }).done(function (payload) {
        if (payload.error) {
            toastr.warning(payload.error.message);
        }
        if (payload.info) {
            toastr.info(payload.info.message);
        }
    });
}

$(document).ready(function () {

    let typingTimer;                //timer identifier
    let doneTypingInterval = 800;  //time in ms
    let $input = $('.ajaxForm-keyup');

    $(document).on("change", ".ajaxForm-change", sendFormData);
    $(document).on("click", ".ajaxForm-click", sendFormData);

    //on keyup, start the countdown
    $input.on('keyup', function () {
        let _this = $(this);
        clearTimeout(typingTimer);
        typingTimer = setTimeout(function(){
            sendFormData(null, _this);
        }, doneTypingInterval);
    });

    //on keydown, clear the countdown
    $input.on('keydown', function () {
        clearTimeout(typingTimer);
    });

    //$(document).on("keyup", ".ajaxForm-keyup", sendFormData);
});
